<template>
	<!-- 센터별 입고 기간(판 #720) — 전체 판매자 · 최근 7일 · 실제 도착 → 진열 시작 · 매일 10시 배치가 저장한 값만 읽음 · 잰 센터가 0개면 카드 자체를 숨긴다
		사장님 10-31 «표 너무 방대 → 차트»: 가로 막대 = 평균 걸린 시간(짧은 순) · 막대 끝에 값 · 1일 미만 «N.N시간» · 1일 이상 «N.N일»(판 #720 [답] A) · 위 8개 + 전체 보기
		사장님 10-31 14:5x·15:3x 덧: 같은 7일·같은 센터 입고 건수 = 보조축 점(기간 일 = 주축 막대 · 건수 건 = 보조축 · 단위 글 둘) · 마우스 오버 = 평균 «N시간 M분» + 건수 · 아래 설명 글 지움 -->
	<div v-if="loaded && (error || (data && data.centers.length))" class="card mb-3 inbound-days">
		<div class="card-body py-3 px-3">
			<div class="d-flex flex-wrap align-items-baseline justify-content-between mb-2">
				<strong class="inbound-days__title">센터별 입고 걸린 시간 <small class="text-muted font-weight-normal">(실제 도착 → 진열 시작)</small></strong>
				<small class="text-muted" v-if="!error && data">최근 {{ data.days }}일 · 매일 10시 갱신<template v-if="computedLabel">({{ computedLabel }} 기준)</template></small>
			</div>
			<p v-if="error" class="text-danger mb-0">{{ error }}</p>
			<template v-else>
				<div class="inbound-days__legend text-muted mb-1">
					<span><i class="inbound-days__key inbound-days__key--bar"></i>걸린 시간(일 · 주축 막대)</span>
					<span><i class="inbound-days__key inbound-days__key--dot"></i>입고 건수(건 · 보조축 점)</span>
				</div>
				<ul class="inbound-days__chart list-unstyled mb-1">
					<li v-for="c in shownCenters" :key="c.fcCode" class="inbound-days__row" tabindex="0"
						@mouseenter="hover = c.fcCode" @mouseleave="hover = ''" @focus="hover = c.fcCode" @blur="hover = ''" @click="hover = c.fcCode">
						<span class="inbound-days__fc" :title="c.fcName">{{ c.fcName }}</span>
						<span class="inbound-days__track">
							<span v-if="c.trimmedMeanDays != null" class="inbound-days__bar" :style="barStyle(c.trimmedMeanDays)"></span>
							<span class="inbound-days__dot" :style="dotStyle(c.count)"></span>
							<span v-if="hover === c.fcCode" class="inbound-days__tip" role="tooltip">
								<strong>{{ c.fcName }}</strong>
								<span>평균 걸린 시간 {{ c.trimmedMeanMinutes != null ? minLabel(c.trimmedMeanMinutes) : '표본 부족(3건 미만)' }}</span>
								<span>입고 {{ c.count }}건</span>
							</span>
						</span>
						<span class="inbound-days__val">
							<strong v-if="c.trimmedMeanDays != null">{{ durLabel(c.trimmedMeanDays) }}</strong>
							<span v-else class="text-muted">표본 부족</span>
						</span>
					</li>
					<li class="inbound-days__row inbound-days__axis text-muted" aria-hidden="true">
						<span>기간(일)</span>
						<span class="inbound-days__ticks"><span>0</span><span>{{ durLabel(maxDays) }}</span></span>
						<span></span>
					</li>
					<li class="inbound-days__row inbound-days__axis text-muted" aria-hidden="true">
						<span>건수(건)</span>
						<span class="inbound-days__ticks"><span>0</span><span>{{ maxCount }}건</span></span>
						<span></span>
					</li>
				</ul>
				<button v-if="data.centers.length > TOP" type="button" class="btn btn-link btn-sm p-0 mb-1 inbound-days__more" @click="showAll = !showAll">
					{{ showAll ? '접기' : `전체 보기 (${data.centers.length}개 센터)` }}
				</button>
			</template>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'InboundDaysByCenter',
	data() {
		return { loaded: false, error: '', data: null, showAll: false, TOP: 8, hover: '' };
	},
	computed: {
		/** 배치 계산 시각 → 'MM-DD HH:mm'(KST) · 없으면 '' */
		computedLabel() {
			const ms = this.data && this.data.computedAt ? Date.parse(this.data.computedAt) : NaN;
			if (!Number.isFinite(ms)) return '';
			const k = new Date(ms + 9 * 3600000).toISOString();
			return `${k.slice(5, 10)} ${k.slice(11, 16)}`;
		},
		/** 배치가 짧은 순으로 저장 · 표본 부족은 뒤 — 위 TOP 개만, 전체 보기면 다 */
		shownCenters() {
			const all = (this.data && this.data.centers) || [];
			return this.showAll ? all : all.slice(0, this.TOP);
		},
		/** 막대 눈금 — 전체 센터 가장 긴 값 기준(펼쳐도 길이가 안 바뀜) · 도착→진열이라 0 이상만 */
		maxDays() {
			const v = ((this.data && this.data.centers) || []).map((c) => c.trimmedMeanDays).filter((x) => x != null);
			return Math.max(0, ...v) || 1;
		},
		/** 보조축 눈금 — 전체 센터 가장 많은 입고 건수 기준 */
		maxCount() {
			return Math.max(0, ...((this.data && this.data.centers) || []).map((c) => c.count || 0)) || 1;
		},
	},
	mounted() {
		this.load();
	},
	methods: {
		/** 일 → 1일 미만 'N.N시간' · 1일 이상 'N.N일' */
		durLabel(days) {
			return days < 1 ? `${(days * 24).toFixed(1)}시간` : `${days.toFixed(1)}일`;
		},
		/** 분 → 'N시간 M분'(오버 · 배치가 반올림 전 평균에서 낸 정수 분) */
		minLabel(min) {
			return `${Math.floor(min / 60)}시간 ${min % 60}분`;
		},
		barStyle(days) {
			return { width: Math.max((days / this.maxDays) * 100, 0.5) + '%' };
		},
		dotStyle(count) {
			return { left: ((count || 0) / this.maxCount) * 100 + '%' };
		},
		async load() {
			try {
				const { data } = await axios.post('/api/getInboundDaysByCenter', {});
				if (!data || !data.ok || !data.inboundDays) {
					this.error = '센터별 입고 걸린 시간을 불러오지 못했어요.';
					return;
				}
				this.data = data.inboundDays;
			} catch (e) {
				console.error('[InboundDaysByCenter] load', e);
				this.error = '센터별 입고 걸린 시간을 불러오지 못했어요.';
			} finally {
				this.loaded = true;
			}
		},
	},
};
</script>

<style scoped>
/* 글자색·바탕은 화면 테마(다크/라이트)를 따른다 · 막대 색만 고정 */
.inbound-days { text-align: left; }
.inbound-days__title { font-size: 1.05rem; }
.inbound-days__row { display: grid; grid-template-columns: 5.5rem 1fr auto; align-items: center; column-gap: 8px; padding: 3px 0; font-size: 0.9rem; }
.inbound-days__fc { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.inbound-days__track { position: relative; height: 14px; border-radius: 3px; background: rgba(128, 128, 128, 0.15); }
.inbound-days__bar { position: absolute; top: 0; bottom: 0; left: 0; border-radius: 3px; background: #4e8cf0; }
.inbound-days__val { white-space: nowrap; text-align: right; min-width: 4rem; }
.inbound-days__row[tabindex] { cursor: default; outline: none; }
.inbound-days__row[tabindex]:focus-visible .inbound-days__track { box-shadow: 0 0 0 2px rgba(78, 140, 240, 0.5); }
.inbound-days__dot { position: absolute; top: 50%; width: 10px; height: 10px; margin: -5px 0 0 -5px; border-radius: 50%; background: #f08c2e; border: 2px solid #fff; box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25); z-index: 1; }
.inbound-days__tip { position: absolute; bottom: calc(100% + 6px); left: 0; z-index: 5; display: flex; flex-direction: column; gap: 1px; padding: 6px 9px; border-radius: 6px; background: rgba(33, 37, 41, 0.95); color: #fff; font-size: 0.8rem; line-height: 1.35; white-space: nowrap; pointer-events: none; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25); }
.inbound-days__tip span, .inbound-days__tip strong { color: #fff; }
.inbound-days__legend { display: flex; flex-wrap: wrap; gap: 4px 14px; font-size: 0.8rem; }
.inbound-days__key { display: inline-block; vertical-align: middle; margin-right: 5px; }
.inbound-days__key--bar { width: 14px; height: 8px; border-radius: 2px; background: #4e8cf0; }
.inbound-days__key--dot { width: 9px; height: 9px; border-radius: 50%; background: #f08c2e; }
.inbound-days__axis { padding: 0; font-size: 0.75rem; }
.inbound-days__ticks { display: flex; justify-content: space-between; }
/* 좁은 화면(≤576px): 센터 이름 칸을 줄이고 값 글씨를 작게 — 390 에서 한 줄 유지 */
@media (max-width: 576px) {
	.inbound-days__row { grid-template-columns: 4.2rem 1fr auto; column-gap: 6px; font-size: 0.82rem; }
	.inbound-days__val { min-width: 3.4rem; }
}
</style>
